import React, {useState} from 'react';
import Layout from 'components/layouts';
import styles from './styles.module.scss';
import {DialogRoot} from '@chakra-ui/react';
import {APP_PATHS, BREAKPOINTS} from '../../constants';
import Dialog from 'components/dialog';
import AuthForm from '../../components/auth-form';
import useWindowSize from 'hooks/useWindowSize';
import {useNavigate} from 'react-router-dom';

const Login: React.FC<any> = () => {
  const [openSingIn, setOpenSignIn] = useState(true);
  const navigate = useNavigate();
  const {width} = useWindowSize();

  return (
    <Layout>
      <div className={styles.wrapper}>
        <DialogRoot
          scrollBehavior="inside"
          size={width < BREAKPOINTS.MD ? 'full' : 'md'}
          onOpenChange={() => {
            setOpenSignIn(!openSingIn);
            navigate(APP_PATHS.BASE);
          }}
          onCloseChange={() => {
            setOpenSignIn(!openSingIn);
            navigate(APP_PATHS.BASE);
          }}
          defaultOpen={true}
        >
          <Dialog isOpen={openSingIn} isAuth={true} contentClassNames={styles.inner}>
            <AuthForm type={'signin'} />
          </Dialog>
        </DialogRoot>
      </div>
    </Layout>
  );
};

export default Login;
